/*
 * File: VisaIcon.tsx
 * Project: meki
 * File Created: Monday, 11th January 2021 5:13:59 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 17th November 2023 11:52:17 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import SvgIcon from '@mui/material/SvgIcon';

export const VisaIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 488.95 150.4" width={40} height={40} {...props}>
      <g id="Mobile---Cuenta">
        <path
          fill="#135c9d"
          d="M500.48,328.88c-9.08,0-17.9.05-26.72,0-3.3,0-7.48,1.39-9.66-.67-1.94-1.83-1.66-5.95-2.52-9-1.09-3.92-.31-9.47-3.31-11.4s-7.94-.57-12-.59c-11.54,0-23.09,0-34.63-.09-2.41,0-3.66.61-4.48,3-1.88,5.45-4.16,10.75-6.1,16.18-.71,2-1.72,2.7-3.88,2.68-11.67-.11-23.35-.14-35,0-3.1,0-3.71-.42-2.34-3.48,8.62-19.16,17.06-38.38,25.53-57.6,10.43-23.67,20.92-47.31,31.2-71.05,3.74-8.63,10-13,19.33-13.08,10,0,20,.05,30-.16,2.78-.06,3.07,1.54,3.49,3.47q10.47,48,20.95,96.07C493.62,298.23,497,313.33,500.48,328.88Z"
          transform="translate(-11.52 -180.8)"
        />
        <path
          fill="#135c9d"
          d="M253.57,290.88c8.47,3.55,16.38,7.23,25.13,8.4,10,1.33,19.89,2.28,29.78-.53a18.74,18.74,0,0,0,6.16-3.07c6.81-5.14,6.76-13.42-.12-18.48a73.67,73.67,0,0,0-11.88-7.06A147,147,0,0,1,280,257.19c-20.81-14.91-18.4-39.94-5.58-54.73,9.9-11.42,23-16.93,37.38-19.74a104.23,104.23,0,0,1,51.69,3.08c2.61.81,3.67,1.68,3,4.77-1.66,7.9-2.92,15.88-4.14,23.87-.47,3-1.08,3.86-4.42,2.49-13.49-5.5-27.44-7.23-41.81-3.85a15.86,15.86,0,0,0-5.86,2.78c-5.66,4.18-6.06,10.83-.68,15.39,6,5.11,13.38,8,20.35,11.53,6.66,3.35,13.11,7,18.69,12,12.91,11.73,16.19,28,8.86,44.12-7.07,15.49-20,23.74-35.6,28.15-23.81,6.71-47.45,4.79-70.83-2.63-2.43-.77-3.06-1.74-2.55-4.37C250.35,310.53,251.86,300.91,253.57,290.88Z"
          transform="translate(-11.52 -180.8)"
        />
        <path
          fill="#135c9d"
          d="M106.83,260.42c1.57,7,3.14,14,4.92,21.93,1.19-2.92,2.07-5,2.91-7.17q14.11-36,28.2-71.92,3.36-8.58,6.54-17.25a3.33,3.33,0,0,1,3.64-2.57q18.11.13,36.2,0c2.66,0,3,.59,1.94,3Q178.67,215.17,166.37,244q-17.43,40.62-34.75,81.29c-1.1,2.61-2.39,3.61-5.31,3.56-11.55-.18-23.1-.15-34.65,0-2.56,0-3.79-.52-4.52-3.21-7.77-28.29-15.7-56.53-23.56-84.79-3.53-12.72-7-25.45-10.5-38.17,1.07-.7,2-.07,2.84.43,20,11.55,35.93,27,47.12,47.32C104.78,253.58,105.62,257.07,106.83,260.42Z"
          transform="translate(-11.52 -180.8)"
        />
        <path
          fill="#135c9d"
          d="M203.4,328.83c-5.51,0-11-.08-16.54,0-2.27.05-3.05-.26-2.59-2.94,4.69-27.12,9.21-54.28,13.78-81.43,3.24-19.2,6.56-38.38,9.68-57.6.43-2.7,1.27-3.64,4.08-3.6,11,.16,22.06.11,33.09,0,2.34,0,3.06.37,2.61,3q-10.89,63-21.54,126.12c-.77,4.54-1.53,9.09-2.07,13.67-.26,2.12-1.09,2.79-3.18,2.75C215,328.75,209.18,328.83,203.4,328.83Z"
          transform="translate(-11.52 -180.8)"
        />
        <path
          fill="#f0a738"
          d="M106.83,260.42A116.06,116.06,0,0,0,76.61,219a119.86,119.86,0,0,0-23.53-16.35c-11.54-6.9-24-11.38-36.95-14.9l-3.35-.87a1.45,1.45,0,0,1-1.25-1.65c.09-1,.49-1.76,1.58-1.85s2.05,0,3.08,0q28.29,0,56.58,0a45.9,45.9,0,0,1,8,.68C87.1,185.19,92,188.59,93.39,195,98.26,216.71,102.81,238.51,106.83,260.42Z"
          transform="translate(-11.52 -180.8)"
        />
        <path
          fill="#fefefe"
          d="M419.74,277.24l20.91-54.38c2.89,13.28,5.53,25.42,8.16,37.55,1,4.76,2,9.53,3.06,14.29.38,1.7.17,2.59-1.93,2.58C440.07,277.2,430.21,277.24,419.74,277.24Z"
          transform="translate(-11.52 -180.8)"
        />
      </g>
    </SvgIcon>
  );
};
